<template>
  <div class="scores-container">
      <div class="risk-score-card">
          <i class="fa fa-briefcase risk-icon"> Employer Benefits </i>
          <button @click="showAddBenefitModal = !showAddBenefitModal">
              <i class="fas fa-plus">Add</i>
          </button>
      </div>
      <div class="benefits-container">
          <div v-if="showAddBenefitModal" class="benefit-form">
              <label>Benefit Name:</label>
              <input type="text" v-model="currentBenefit.benefit_name" placeholder="Benefit Name"><br>
              <label>Maximum coverage amount:</label>
              <input type="number" v-model="currentBenefit.total_amount" placeholder="Total Amount"><br>
              <label>Amount Used:</label>
              <input type="number" v-model="currentBenefit.amount_used" placeholder="Amount Used"><br>
              <label>Expiry date:</label>
              <input type="date" v-model="currentBenefit.expiry_date" placeholder="Expiry Date"><br>
              <button @click="isEditing ? updateBenefit() : addBenefit()">
                  {{ isEditing ? 'Update Benefit' : 'Add Benefit' }}
              </button>
          </div>

          <table>
              <tr>
                  <th>Benefit Name</th>
                  <th>Maximum Coverage Amount</th>
                  <th>Amount Used</th>
                  <th>Amount Remaining</th>
                  <th>Days Remaining</th>
                  <th>Expiry Date</th>
                  <th>Actions</th>
              </tr>
              <tbody>
                  <tr v-for="(benefit, index) in benefits" :key="index">
                      <td data-label="Benefit Name">{{ benefit.benefit_name }}</td>
                      <td data-label="Maximum Coverage Amount">${{ benefit.total_amount }}</td>
                      <td data-label="Amount Used">${{ benefit.amount_used }}</td>
                      <td data-label="Amount Remaining">$ {{ benefit.total_amount - benefit.amount_used }}</td>
                      <td data-label="Expiry Date">{{ benefit.expiry_date }}</td>
                      <td data-label="Days Remaining">{{ calculateDaysRemaining(benefit.expiry_date) }} days</td>
                      <td data-label="Actions">
                          <button @click="selectBenefitForUpdate(benefit, index)">Edit</button>
                      </td>
                  </tr>
              </tbody>
          </table><br>
      </div>
  </div><br>
</template>

<script>
import axios from 'axios';
import { Auth } from 'aws-amplify';

export default {
  data() {
    return {
      benefits: [],
      currentBenefit: {
        id: null,
        benefit_name: '',
        total_amount: 0,
        amount_used: 0,
        expiry_date: null
      },
      selectedBenefitIndex: null,
      showAddBenefitModal: false,
      isEditing: false
    };
  },
  methods: {
    async fetchBenefits() {
      const user = await Auth.currentAuthenticatedUser();
      const response = await axios.get('https://api.riskypaws.com/frontoffice/api/employer-benefit/', {
        headers: { 'X-Cognito-Sub': user.attributes.sub }
      });
      this.benefits = response.data;
    },
    selectBenefitForUpdate(benefit, index) {
      this.currentBenefit = { ...benefit };
      this.selectedBenefitIndex = index;
      this.showAddBenefitModal = true;
      this.isEditing = true;
    },
    async updateBenefit() {
      const user = await Auth.currentAuthenticatedUser();
      await axios.put(`https://api.riskypaws.com/frontoffice/api/employer-benefit/${this.currentBenefit.id}/`, this.currentBenefit, {
        headers: { 'X-Cognito-Sub': user.attributes.sub }
      });
      this.resetForm();
      await this.fetchBenefits();
    },
    resetForm() {
      this.currentBenefit = { id: null, benefit_name: '', total_amount: 0, amount_used: 0 };
      this.showAddBenefitModal = false;
      this.isEditing = false;
    },
    async addBenefit() {
      const user = await Auth.currentAuthenticatedUser();
      await axios.post('https://api.riskypaws.com/frontoffice/api/employer-benefit/', this.currentBenefit, {
        headers: { 'X-Cognito-Sub': user.attributes.sub }
      });
      this.resetForm();
      await this.fetchBenefits();
    },
    calculateDaysRemaining(expiryDate) {
    if (!expiryDate) return 'N/A'; // Handle cases where expiry date is not set

    const today = new Date();
    const expiry = new Date(expiryDate);
    const timeDiff = expiry - today;
    return Math.ceil(timeDiff / (1000 * 60 * 60 * 24)); // Convert milliseconds to days
  },
  },
  created() {
    this.fetchBenefits();
  }
};
</script>

<style scoped>

.risk-score-card {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 15px;
  margin-bottom: 20px;
  background-color: #36454f;
  color: white;
  font-size: 24px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-color: #4A148C;
  justify-content: space-between; /* Aligns items to start and end */
  }
  .scores-container {
    display: flex;
    flex-wrap: wrap; /* Allows items to move to the next row on smaller screens */
    justify-content: center; /* Centers items */
    align-items: center;
    width: 100%;
    border: 2px solid #000;
    border-radius: 10px;
    padding: 20px;
    box-sizing: border-box;
    background-color: white; 
  }

  .edit-btn {
  background: none;
  border: none;
  cursor: pointer;
}

.edit-btn i {
  font-size: 16px;
  color: #4A148C; /* Dark purple */
}

button {
  background-image: linear-gradient(135deg, #6D5BBA 0%, #8D58BF 100%); /* Apply the same gradient as your app theme */
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  margin: 5px;
  cursor: pointer;
  transition: background-color 0.3s, box-shadow 0.3s;
}

button:hover {
  background-image: linear-gradient(135deg, #8D58BF 0%, #6D5BBA 100%); /* Slightly adjust gradient for hover effect */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* Add a shadow for depth */
}


table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

th, td {
  border: 1px solid #4A148C;
  padding: 8px;
  text-align: left;
}

th {
  background-color: #f4f4f4;
  color: #333;
  
}
@media (max-width: 768px) {
  .benefits-container table, 
  .benefits-container thead, 
  .benefits-container tbody, 
  .benefits-container tr { 
    display: block; 
    width: 100%;
  }

  .benefits-container th { 
    display: none; /* Hide table headers */
    width: 100%;
  }

  .benefits-container td { 
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #ddd;
  }

  .benefits-container td:before { 
    content: attr(data-label);
    font-weight: bold;
    flex-basis: 40%;
  }

  .benefits-container td[data-label="Actions"] button {
    flex-grow: 1;
  }
}
.benefit-form label {
  display: block;
  margin: 10px 0;
}
table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}
.benefit-form  input[type="text"],
.benefit-form  input[type="number"],
.benefit-form  select {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ddd;
  box-sizing: border-box;
}

@media screen and (max-width: 600px) {
  .risk-score-card, .toolbar button, .event-form label, .event-form input, .event-form select, .event-form button {
    font-size: 14px; /* Adjust font size for better readability on mobile */
  }

  .button, .toolbar button {
    padding: 8px 10px; /* Adjust button padding for easier clickability */
    margin: 4px; /* Reduce margin to fit more content */
  }

  .event-form {
    grid-template-columns: 1fr; /* Adjust form layout to single column for narrow screens */
  }

  input[type="date"], input[type="text"], input[type="number"], select {
    margin: 4px 0; /* Reduce margin around inputs for compact layout */
  }

  .event-form button {
    padding: 8px 10px; /* Adjust button size for mobile */
  }

  table, th, td {
    font-size: 12px; /* Smaller table font size for mobile */
    width: 100%;
  }
}

  </style>